import React, { useState } from 'react'
import DownArrow from 'components/icons/DownArrow'
import { Dropdown, Modal } from 'antd'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import {
  StyledDropDownButton,
  ButtonText,
  Main,
  ActionMenu,
  ItemText,
  ItemDeleteText,
  SmallButtons,
} from 'components/ActionStyles/ActionStyles'
import PlacementHistoryWithResume from '../../../../../components/UIComponents/PlacementHistoryWithResume/index.js'
import BlacklistDrawer from 'modules/Students/Partials/StudentsInfoTable/BlacklistDrawer'
import { StyledButton } from '../../../../../components/ActionStyles/ActionStyles'
const { confirm } = Modal

const ActionsStudent = ({
  needViewButton = true,
  studentId,
  getSingleStudentData,
  deleteStudent,
  singleStudentData,
  onEditStudent,
  data,
  blacklistStudent,
  activeInactivateStatus,
  reInviteStudent,
  cruds,
  eventId,
  matchingTemplate,
  sendNotificationEmail,
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
  getPreview,
  setCurrentPage,
  currentUrl,
  counter,
  setCounter,
  viewOnly = false,
  setSelectedStudents
}) => {
  const [viewDrawer, setViewDrawer] = useState(false)
  const [visible, setVisible] = useState(false)
  const [blacklistDrawer, setBlacklistDrawer] = useState(false)
  const [blacklistStudentId, setBlacklistStudentId] = useState('')

  const handleMenuClick = async (id, event) => {
    event.preventDefault()
    event.stopPropagation()
    setVisible(!visible)
    setViewDrawer(true)
    await getSingleStudentData(id)
  }

  const handleBlacklist = id => {
    setViewDrawer(false)
    setBlacklistDrawer(true)
    setBlacklistStudentId(id)
    getSingleStudentData(id)
  }

  const onDelete = async (id, data) => {
    setCounter(counter + 1)
    let response = await deleteStudent(id)
    if (response?.data?.data?.email) {
      let name = data?.firstName + ' ' + data?.lastName
      let template
      template = matchingTemplate?.templateText.replace('{studentName}', name)
      let mailObj = {
        to: response?.data?.data?.email,
        subject:
        matchingTemplate?.subject ||
        'Notification of Pluginlive Account Deletion',
        htmlBody: template,
      }
      sendNotificationEmail(mailObj)
    }
    setCurrentPage(0)
    setSelectedStudents([])
  }
  const showConfirm = (id, data) => {
    confirm({
      title: 'Do you want to delete this student?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onDelete(id, data)
        setSelectedStudents([])
      },
      onCancel() {},
      okText: 'Delete',
    })
  }
  const activateInactivate = async (id, currentStatus) => {
    let payload
    if (currentStatus == 2) {
      payload = {
        status: -2,
      }
    } else {
      payload = {
        status: 2,
      }
    }

    await activeInactivateStatus(id, payload)
    setVisible(false)
    setCurrentPage(0)
    setCounter(counter + 1)
  }
  const handleInvite = (event, data) => {
    reInviteStudent(data.id, eventId)
    setVisible(false)
  }
  let menuItems = [
    {
      key: 'edit',
      hidden: !cruds?.includes('EDIT'),
      label: <ItemText>Edit Profile</ItemText>,
      onClick: () => onEditStudent(studentId),
    },
    {
      key: 'invite',
      label: 'Resend Invite',
      // onClick: () => handleInvite(data),
      onClick: event => handleInvite(event, data), // Pass event and data
      hidden: !cruds?.includes('RESENT INVITE'),
      disabled: data.status != 0,
    },
    {
      key: 'blacklist',
      hidden: !cruds?.includes('BLACKLIST') || data?.status == '0',

      label: data?.status == -1 ? 'Blacklist' : <ItemText>Blacklist</ItemText>,
      onClick: () => handleBlacklist(studentId),
      disabled: data?.status == -1,
    },
    {
      key: 'active',
      hidden: !cruds?.includes('ACTIVE/INACTIVE'),

      label: data?.status == 2 ? 'Inactivate' : 'Activate',
      disabled: data?.status == 0 || data?.status == -3,
      onClick: () => activateInactivate(studentId, data?.status),
    },
    {
      type: 'divider',
      hidden: !cruds?.includes('DELETE'),
    },
    {
      key: 'delete',
      hidden: !cruds?.includes('DELETE'),

      label: <ItemDeleteText>Delete Student</ItemDeleteText>,
      onClick: () => showConfirm(studentId, data),
    },
  ]?.filter(item => !item?.hidden)
  const menu = <ActionMenu width={'165px'} items={menuItems} />
  const getPopupContainer = () => {
    const container = document.getElementById('FilterDropdown')
    return container
  }
  return (
    <>
      {needViewButton ? (
        <Main>
          {menuItems?.length && !viewOnly ? (
            <div id="FilterDropdown">
              <StyledDropDownButton
                overlay={menu}
                visible={visible}
                onVisibleChange={setVisible}
                shape="round"
                onClick={event => handleMenuClick(studentId, event)}
                trigger={['click']}
                icon={<DownArrow />}
                getPopupContainer={getPopupContainer}
              >
                <ButtonText>View</ButtonText>
              </StyledDropDownButton>
            </div>
          ) : (
            <StyledButton onClick={e => handleMenuClick(studentId, e)}>
              View
            </StyledButton>
          )}
        </Main>
      ) : (
        <Dropdown
          overlay={menu}
          trigger={['click']}
          id="FilterDropdown"
          getPopupContainer={() => document.getElementById('FilterDropdown')}
        >
          <a onClick={e => e.preventDefault()} href="/">
            <SmallButtons height={'38px'} icon={<VerticalThreeDots />} />
          </a>
        </Dropdown>
      )}

      {singleStudentData?.firstName ? (
        <PlacementHistoryWithResume
          studentId={studentId}
          isOpenHistory={viewDrawer}
          setIsOpenHistory={setViewDrawer}
          getJobRolePreview={getJobRolePreview}
          getStudentPlacedList={getStudentPlacedList}
          getPlacementHistoryList={getPlacementHistoryList}
          getPreview={getPreview}
        />
      ) : null}

      <BlacklistDrawer
        blacklistDrawer={blacklistDrawer}
        setBlacklistDrawer={setBlacklistDrawer}
        singleStudentData={singleStudentData}
        blacklistStudent={blacklistStudent}
        blacklistStudentId={blacklistStudentId}
        counter={counter}
        setCounter={setCounter}
        setCurrentPage={setCurrentPage}
      />
    </>
  )
}

export default ActionsStudent
